<template>
  <div
    :class="[{'show-overlay': $store.state.app.shallShowOverlay}, $route.meta.contentClass]"
    class="app-content content main-wrapper"
  >
    <div class="content-overlay" />
    <HeaderPages :title="$t('Tasks')" />
    <transition :name="routerTransition" mode="out-in" id="" transition-path="">
      <div :class="contentWidth === 'boxed' ? 'container p-0' : null" class="content-area-wrapper tw-border-gray-200 tw-flex-grow">
        <slot name="breadcrumb">
          <app-breadcrumb />
        </slot>
        <portal-target name="content-renderer-sidebar-left" slim />
        <div class="content-right">
          <div class="content-wrapper">
            <div class="content-body">
              <slot />
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import AppBreadcrumb from '@core/layouts/components/AppBreadcrumb.vue'
import useAppConfig from '@core/app-config/useAppConfig'
import HeaderPages from '@/components/HeaderPages.vue'

export default {
  components: {
    AppBreadcrumb,
    HeaderPages,
  },
  setup() {
    const {routerTransition, contentWidth} = useAppConfig()

    return {
      routerTransition,
      contentWidth,
    }
  },
}
</script>

<style></style>
